import { Activityeditor } from '@linktivity/link-connect';
import config from '../config';

const adminApi = new Activityeditor.AdminApi(config);

export default adminApi;
